import ResInterceptors from './ResInterceptors'
export default ResInterceptors

